<script lang="ts">
  import {
    useNavigate,
    useLocation,
    NavigateFn,
    NavigatorLocation,
  } from "svelte-navigator";
  import type AnyObject from "svelte-navigator/types/AnyObject";
  import type { Readable } from "svelte/store";
  import { get } from "svelte/store";
  import {
    isCurrentUserLoaded,
    isLoggedIn,
    currentUserStore,
    userInfoStore,
  } from "../app/store/store-user";
  import { redirectTo } from "../PageUrl";
  import pageUrl from "../PageUrl";

  // const navigate: NavigateFn = useNavigate();
  const location: Readable<NavigatorLocation<AnyObject>> = useLocation();

  function handleRedirectPages() {
    if (!isUserLoaded) return;

    // User is not login, redirect to login page
    if (!loggedIn) {
      redirectTo(pageUrl.SIGNIN, {}, false, {
        state: { from: $location.pathname },
        replace: true,
      });
      return;
    }

    if (!userInfo) return;
    // User is logged in but not verify, redirect to register page
    const user = get(currentUserStore);
    if (!user.emailVerified) {
      redirectTo(pageUrl.REGISTER);
      return;
    }

    // user not have plan yet
    if (!userInfo.plan) {
      redirectTo(pageUrl.REGISTER, {page: "account_type"});
      return;
    }
  }

  $: loggedIn = $isLoggedIn;
  $: isUserLoaded = $isCurrentUserLoaded;
  $: userInfo = $userInfoStore;
  $: loggedIn, isUserLoaded, userInfo, handleRedirectPages();
</script>

{#if isUserLoaded && loggedIn}
  <slot />
{/if}
